function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.468 30.172a4.102 4.102 0 11-8.205 0 4.102 4.102 0 018.205 0z",
  fill: "#FFCE32"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.08 50.253h10.796V34.706l11.228-4.75 11.66 4.318v15.87h53.118v14.36H2.08V50.253z",
  fill: "#F8FBCF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 69.254h90.177V.718H0v68.536z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Delivery_svg__a)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.899 41.616h4.318v-4.318H15.9v4.318zM15.899 49.39h4.318V45.07H15.9v4.319z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.08 69.254h87.233v-9.5H2.08v9.5z",
  fill: "#F2F4F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.806 57.181h36.337v-37.59H52.806v37.59z",
  fill: "#FFCE32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.806 57.669V27.98H39.9l-6.131 11.94-10.15 4.845v12.903h29.189z",
  fill: "#FFCE32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.895 57.871h68.282v-5.518H21.894v5.518z",
  fill: "#406367"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.317 39.92h12.908V29.918h-8.067l-4.84 10.004z",
  fill: "#D2B982"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.708 44.761h4.84v-1.936h-4.84v1.936zM47.382 29.917l-3.61 10.004h-6.777l4.84-10.004h5.547z",
  fill: "#F8FBCF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.66 43.313l-3.041 5.591v-4.138l3.041-1.453z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.587 19.59l36.36 32.762h-36.36V19.591z",
  fill: "#F8FBCF"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.122 50.144h13.96v13.96h-13.96v-13.96z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Delivery_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.174 50.79a6.978 6.978 0 109.263 3.406 6.98 6.98 0 00-9.263-3.407z",
  fill: "#002F34"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.982 54.701a2.67 2.67 0 11-1.303 3.544 2.673 2.673 0 011.303-3.544z",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M69.23 50.144h13.96v13.96H69.23v-13.96z",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Delivery_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M73.281 50.79a6.978 6.978 0 105.857 12.668 6.978 6.978 0 00-5.856-12.67v.001z",
  fill: "#002F34"
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M75.09 54.701a2.67 2.67 0 112.242 4.847A2.67 2.67 0 0175.09 54.7z",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.804 36.002H2.558L0 33.886v-19.73l2.075-1.828 19.85-.078 2.192 1.907v19.729l-2.313 2.116z",
  fill: "#23E5D8"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.495 18.295a3.239 3.239 0 00-3.174-3.887c-.513 0-.996.123-1.427.335a5.823 5.823 0 00-10.788 1.896 2.144 2.144 0 00-.525-.071 2.16 2.16 0 00-2.115 1.727h18.03z",
  fill: "#EBF2FF"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71.965 8.363c.049-.24.075-.727.075-.98a3.703 3.703 0 00-3.703-3.703c-.587 0-1.14.14-1.632.383A6.657 6.657 0 0054.373 6.23a2.46 2.46 0 00-.6-.082c-1.195 0-2.19 1.088-2.42 2.215h20.612z",
  fill: "#3A77FF"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M5.803 24.096l4.968 4.258 9.225-9.226",
  stroke: "#002F34",
  strokeWidth: 4.68
});

const SvgDelivery = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 91,
  height: 70,
  fill: "none"
}, props), _ref, _ref2, /*#__PURE__*/React.createElement("mask", {
  id: "Delivery_svg__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 91,
  height: 70
}, _ref3), _ref4, /*#__PURE__*/React.createElement("mask", {
  id: "Delivery_svg__b",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 26,
  y: 50,
  width: 15,
  height: 15
}, _ref5), _ref6, _ref7, /*#__PURE__*/React.createElement("mask", {
  id: "Delivery_svg__c",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 69,
  y: 50,
  width: 15,
  height: 15
}, _ref8), _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);

export default SvgDelivery;